import { render, staticRenderFns } from "./DepartureForm.vue?vue&type=template&id=0d937b8b&scoped=true&lang=pug"
import script from "./DepartureForm.vue?vue&type=script&lang=js"
export * from "./DepartureForm.vue?vue&type=script&lang=js"
import style0 from "./DepartureForm.vue?vue&type=style&index=0&id=0d937b8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d937b8b",
  null
  
)

export default component.exports